
export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-gift-line',
      title: 'Pengecekan Laptop GRATIS',
      description: 'Dapatkan diagnosa gratis untuk masalah laptop Anda sebelum memutuskan untuk servis'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garansi Pengerjaan',
      description: 'Garansi 2–5 bulan untuk servis tertentu, memberikan ketenangan pikiran untuk Anda'
    },
    {
      icon: 'ri-team-line',
      title: 'Cocok untuk Semua',
      description: 'Melayani UMKM, masjid, sekolah, dan rumah tangga dengan solusi yang tepat'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Order Online Mudah',
      description: 'Pesan layanan dengan mudah melalui WhatsApp, kapan saja dan dimana saja'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Harga Terjangkau',
      description: 'Harga kompetitif dan transparan tanpa biaya tersembunyi'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Pelayanan Profesional',
      description: 'Tim berpengalaman dan terlatih siap memberikan layanan terbaik untuk Anda'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
              Keunggulan Kami
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
            Mengapa Memilih Kami?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Kepercayaan pelanggan adalah prioritas utama kami
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#FF8A00] hover:-translate-y-2"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#0B1F3B] to-[#0d2847] rounded-2xl mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className={`${reason.icon} text-4xl text-[#FF8A00]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#0B1F3B] mb-3 group-hover:text-[#FF8A00] transition-colors">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] rounded-3xl p-8 md:p-12 max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="w-24 h-24 flex items-center justify-center bg-[#FF8A00] rounded-full flex-shrink-0">
              <i className="ri-star-smile-line text-5xl text-white"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                Siap Melayani Anda dengan Sepenuh Hati
              </h3>
              <p className="text-gray-300 text-lg">
                Hubungi kami sekarang dan dapatkan solusi terbaik untuk kebutuhan digital Anda
              </p>
            </div>
            <a
              href="https://wa.me/6285868360910"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Hubungi Kami
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
